import ISlug from '@/interfaces/ISlug';
import IState from '@/interfaces/IState';

export default (state: IState, osDevices: ISlug[]) => {
    state.osDevices = osDevices;
};
